(function ($) {
    $.fn.textColorChanger = function () {
        var $self = $(this);
        var $teams = $self.find('.js-color-changer-team');
        var goalFirst = parseInt($self.find('.js-color-changer-goal-first').text());
        var goalLast = parseInt($self.find('.js-color-changer-goal-last').text());

        var init = function () {
            if(isNaN(goalLast) || isNaN(goalFirst)) {
                return;
            }

            if (goalFirst > goalLast) {
                $teams.eq(1).addClass('loser');
            }
            if (goalLast > goalFirst) {
                $teams.eq(0).addClass('loser');
            }
        };
        init();
    };
    $('.js-color-changer').each(function() {
        $(this).data('textColorChanger', $(this).textColorChanger());
    });
})(jQuery);
